import { services, businessInfo } from "@/mocks/home";

export default function Services() {
  return (
    <section id="servicios" className="w-full bg-gradient-to-b from-primary-50 via-background-50 to-primary-50">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="text-center max-w-2xl mx-auto mb-14 md:mb-16">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold uppercase tracking-wider mb-5">
              <i className="ri-microscope-line"></i>
              Nuestros servicios
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight tracking-tight">
              Estudios confiables, resultados que tranquilizan
            </h2>
            <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
              Realizamos análisis clínicos, ultrasonido, electrocardiograma y rayos X con la precisión
              que tu salud merece. Llevamos <strong className="text-primary-700 font-semibold">análisis
              clínicos, electrocardiogramas y rayos X a domicilio</strong>. Si no ves tu estudio en la lista,
              llámanos o contáctanos por WhatsApp y con gusto te orientamos.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            {services.map((service) => (
              <article
                key={service.title}
                className="group bg-background-50 border border-background-200/80 border-t-4 border-t-primary-500 rounded-lg overflow-hidden flex flex-col hover:border-primary-300 hover:border-t-primary-600 transition-colors"
              >
                <div className="relative w-full h-56 md:h-64 overflow-hidden bg-primary-100">
                  <img
                    src={service.image}
                    alt={service.title}
                    title={`${service.title} en Laboratorio Clínico ANEDAN`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 via-primary-900/10 to-transparent"></div>
                  {service.badge && (
                    <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs font-semibold tracking-wide">
                      <i className="ri-home-smile-line"></i>
                      {service.badge}
                    </span>
                  )}
                  <span className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/90 text-primary-800 text-xs font-semibold backdrop-blur-sm">
                    <i className="ri-list-check-2"></i>
                    {service.items.length} estudios
                  </span>
                </div>
                <div className="p-6 md:p-8 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors">
                      <i className={`${service.icon} text-2xl`}></i>
                    </span>
                    <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                    {service.description}
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 mb-8">
                    {service.items.map((item) => (
                      <li key={item} className="flex items-start gap-2 text-sm text-foreground-700">
                        <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5 flex-shrink-0"></i>
                        <span className="leading-snug">{item}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href={businessInfo.whatsappLink}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    Agendar este estudio
                  </a>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-8 md:mt-10 bg-accent-500 rounded-lg p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4 text-center md:text-left flex-col md:flex-row">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/20 flex-shrink-0">
                <i className="ri-question-line text-2xl text-background-50"></i>
              </span>
              <div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50">
                  ¿No sabes qué estudio necesitas?
                </h3>
                <p className="text-sm md:text-base text-background-50/90 mt-1">
                  Cuéntanos qué sientes o trae la orden de tu médico. Te guiamos con paciencia.
                </p>
              </div>
            </div>
            <a
              href={businessInfo.phoneLink}
              className="flex-shrink-0 flex items-center gap-2 px-6 py-3.5 rounded-md bg-background-50 text-accent-700 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              Llámanos ahora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}